import Component from "@glimmer/component"
import type { UserSummary } from "@shared/models/user"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"

interface Sig {
  Args: {
    userId: string
  }
  Blocks: {
    default: [model: FindDoc<"user-summary", UserSummary>]
  }
}

export default class ContainerUserSummary extends Component<Sig> {
  @use model = new FindDoc(() => ["user-summary", this.args.userId])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    ContainerUserSummary: typeof ContainerUserSummary
  }
}
